import {
  LOAD_PRICELIST,
  SHOW_PRICELIST,
  CREATE_PRICELIST,
  UPDATE_PRICELIST,
  DELETE_PRICELIST,
  IMPORT_PRICELIST,
  EXPORT_PRICELIST,
  LOAD_PRICELIST_PRODUCTS,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    pricelist: {
      id: "",
      code: "",
      name: "",
      company_id: "",
      company_name: "",
      created_at: "",
      updated_at: "",
    },
    detail: [],
    plants: [],
    priceDate: []
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PRICELIST.REQUEST:
    case SHOW_PRICELIST.REQUEST:
    case CREATE_PRICELIST.REQUEST:
    case UPDATE_PRICELIST.REQUEST:
    case DELETE_PRICELIST.REQUEST:
    case EXPORT_PRICELIST.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_PRICELIST_PRODUCTS.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case IMPORT_PRICELIST.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_PRICELIST.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_PRICELIST.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_PRICELIST.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
        shouldReload: true
      };

    case UPDATE_PRICELIST.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
        shouldReload: true
      };

    case DELETE_PRICELIST.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_PRICELIST.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_PRICELIST.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };

    case LOAD_PRICELIST_PRODUCTS.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          products: action.payload.data.data,
        },
        loading: false,
      };
    case LOAD_PRICELIST.FAILURE:
    case SHOW_PRICELIST.FAILURE:
    case CREATE_PRICELIST.FAILURE:
    case UPDATE_PRICELIST.FAILURE:
    case DELETE_PRICELIST.FAILURE:
    case IMPORT_PRICELIST.FAILURE:
    case EXPORT_PRICELIST.FAILURE:
    case LOAD_PRICELIST_PRODUCTS.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
